import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { totraJobRetrieveRequest } from 'actions/jobs/employees';
import { isToTraJobDetailLoading } from 'selectors/loading';
import EmployeeJobDetailHOC from './EmployeeJobDetailHOC';
import JobDetail from './presenter';


const mapStateToProps = (state, props) => {
  const { id } = props.params;
  return {
    id,
    roleKey: 'totra',
    isLoading: isToTraJobDetailLoading(state, id),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    retrieveRequest: totraJobRetrieveRequest,
  }, disptach)}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeJobDetailHOC(JobDetail));
